// HeaderMobileMenu — placeholder reservado del refactor P3.1 (feb-2026).
//
// El Header actual de DamyxIA NO usa un menú hamburguesa: en mobile se
// adapta automáticamente vía flex + scroll horizontal en `.header-right-scroll`
// (ver Header.jsx). Mantenemos este archivo como punto de extensión para
// una futura UI mobile (sheet/drawer lateral) sin re-introducir features
// no autorizadas en este refactor.
//
// IMPORTANTE: respeta el contrato del cuadro negro pero NO introduce
// comportamiento nuevo. Hoy retorna null.
const HeaderMobileMenu = () => null;

export default HeaderMobileMenu;
